import { path } from "ramda";

export const selector = path(["monitoringQueueEntries", "data"]);

export const exportEntries = path(["monitoringQueueEntries", "exportEntries"]);

export const filtersSelector = path(["monitoringQueueEntries", "filters"]);

export const riskFactorsSelector = path([
  "monitoringQueueEntries",
  "riskFactors",
]);

export const pageInfoSelector = path(["monitoringQueueEntries", "pageInfo"]);

export const monitoringQueueIsLoadingSelector = path([
  "monitoringQueueEntries",
  "isLoading",
]);

export const selectTableCheckboxChecked = path([
  "monitoringQueueEntries",
  "tableDropdownChecked",
]);

export const selectTableHeaderDropdownValue = path([
  "monitoringQueueEntries",
  "tableHeaderDropdownValue",
]);

export const selectSelectedEntries = path([
  "monitoringQueueEntries",
  "selectedEntries",
]);

export const selectDeselectedEntries = path([
  "monitoringQueueEntries",
  "deselectedEntries",
]);

export const monitoringQueueIsExportLoadingSelector = path([
  "monitoringQueueEntries",
  "isExportLoading",
]);

export const detailsSelector = path(["monitoringQueueEntryDetails", "data"]);

export const reloadSelector = path(["monitoringQueueEntryDetails", "reload"]);

export const isLoadingSelector = path([
  "monitoringQueueEntryDetails",
  "isLoading",
]);

export const selectIsLoadingUpdateScoringResultStatus = path([
  "monitoringQueueEntryDetails",
  "isLoadingUpdateScoringResultStatus",
]);

export const noEntriesMessageSelectorMonitoringQueue = path([
  "monitoringQueueEntries",
  "noEntriesMessage",
]);

export const createWatchListIgnoringPropertyIsLoading = path([
  "monitoringQueueEntryDetails",
  "isLoadingIgnoringProperties",
]);

export const selectScoringDecisionTemplate = path([
  "getScoringDecisionTemplate",
  "scoringDecisionTemplate",
]);

export const isLoadingScoringDecisionTemplate = path([
  "getScoringDecisionTemplate",
  "isLoading",
]);



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/selectors/index.js